module.exports = __webpack_public_path__ + "assets/img/three.6b89278e.png";